module.exports = "./img/2c1aed96b2edccff913faf82048ce91b.png";